var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_radial_50_140)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_140)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_140)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_50_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 16.628L24.004 14L33 16.628V22.017C32.9999 24.7789 32.1307 27.4708 30.5156 29.7112C28.9005 31.9516 26.6213 33.627 24.001 34.5C21.38 33.6269 19.1002 31.9512 17.4847 29.7102C15.8692 27.4692 14.9999 24.7766 15 22.014V16.628Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.5L23 27L29 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_50_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0614 1.7561) rotate(90.0761) scale(46.2439 46.2439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357CD2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_50_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIcon6);
export default __webpack_public_path__ + "static/media/f_icon6.86dd4814eb4893b5d30e178fadf92e30.svg";
export { ForwardRef as ReactComponent };